// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lm3J","label":"styles_label__30Q57"};